// extracted by mini-css-extract-plugin
module.exports = {"container":"cookiePage_container__2dY8p","hide":"cookiePage_hide__2TCf5","display":"cookiePage_display__1a5YG"};
    if(module.hot) {
      // 1744882509257
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  